import { Actie, useAcceptActie, useGetDossierActiesById } from "@/entities/actie";
import { BusEvacuatieActie, GewijzigdeBusEvacuatieActieVelden } from "@/entities/actie/domain/bus-evacuatie";
import { ErrorDisplay, MessageBarGezien } from "@/shared/components";
import { joinWithCommasAndEn } from "@/shared/utils";

const gewijzigdeVeldenMap: Record<GewijzigdeBusEvacuatieActieVelden, string> = {
    AantalBussen: "het aantal bussen",
    OpstelLocatie: "de opstellocatie",
    AfzetStation: "het afzetstation",
};

function createBusEvacuatieWijzigingActieSelector(forTreinId: number) {
    return (acties: Actie[]): BusEvacuatieActie | undefined => {
        return acties.find(
            (actie): actie is BusEvacuatieActie =>
                Actie.isBusEvacuatieActie(actie) && actie.wijzigingType === "Gewijzigd" && actie.treinId === forTreinId
        );
    };
}

type EvacuatieBusGewijzigdeVeldenProps = {
    dossierId: string;
    treinId: number;
};

export function EvacuatieBusGewijzigdeVelden({ dossierId, treinId }: EvacuatieBusGewijzigdeVeldenProps) {
    const { mutate: acceptActie, error } = useAcceptActie();
    const { data: actie } = useGetDossierActiesById<BusEvacuatieActie | undefined>(dossierId, {
        select: createBusEvacuatieWijzigingActieSelector(treinId),
    });

    const gewijzigdeVelden = actie?.nieuweWaarde.gewijzigdeVelden;
    if (!gewijzigdeVelden || gewijzigdeVelden.length === 0) {
        return null;
    }
    const gewijzigdeVeldenSentence = joinWithCommasAndEn(gewijzigdeVelden.map((wijziging) => gewijzigdeVeldenMap[wijziging]));

    const [first, last] = gewijzigdeVeldenSentence.split(" en "); // separate the parts before and after the "en" for styling reasons

    const handleSeen = () => {
        acceptActie({ dossierId, actieId: actie.id });
    };

    return (
        <>
            <MessageBarGezien className="flex justify-between" onClose={handleSeen}>
                De regievoerder heeft <span className="font-bold">{first}</span>
                {last ? " en" : ""} {last ? <span className="font-bold">{last}</span> : ""} van de evacuatiebus gewijzigd.
            </MessageBarGezien>
            {error && <ErrorDisplay error={error} />}
        </>
    );
}
